export interface PostAuthState {
  isConsumer: boolean;
  isPrestador: boolean;
  needsOnboarding: boolean;
}

/**
 * Decides where to send a freshly-authenticated user.
 * Order: consumer → /app; prestador → /meus-servicos; sem tipo escolhido
 * (sem org e sem consumer) → /conta/escolher; senão → /painel.
 */
export function resolvePostAuthPath(state: PostAuthState): string {
  if (state.isConsumer) return '/app';
  if (state.isPrestador) return '/meus-servicos';
  if (state.needsOnboarding) return '/conta/escolher';
  return '/painel';
}
